class Limit {
    readonly HISTORY = 10
    readonly TOCS = 100
    readonly DRUGS = 100
    readonly BAND_FILES = 100
    readonly RELATED_DOCS = 100
}

export const LIMIT_VAL_FOR = new Limit()